import styled from 'styled-components'
import InputMask from 'react-input-mask'
import PropTypes from 'prop-types'

import LabelledField from 'components/LabelledField'

const propTypes = {
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  errorMessage: PropTypes.string,
  className: PropTypes.string
}

const defaultProps = {
  isRequired: false,
  errorMessage: '',
  className: ''
}

const PhoneInput = ({ label, isRequired, errorMessage, className, ...inputProps }) => {
  const id = label.replace(' ', '_')
  let inputMask = '(999) 999-9999'

  if (inputProps.value && inputProps.value.length === 11) {
    inputMask = '9 (999) 999-9999'
  }
  return (
    <LabelledField {...{ id, label, isRequired, errorMessage, className }}>
      <S.InputMask mask={inputMask} type="tel" maskChar={null} {...{ id, ...inputProps }} />
    </LabelledField>
  )
}

PhoneInput.propTypes = propTypes
PhoneInput.defaultProps = defaultProps

export default PhoneInput

const S = {
  InputMask: styled(InputMask)`
    height: 39px;
    width: 100%;
    border-radius: 4px;
  `
}
